module.exports = __webpack_public_path__ + "static/media/furqan-2.a3a2d246.jpg";